import { useEffect } from 'react';
import { useQueryParams } from 'catering/hooks/useQueryParams';
import { useCreateCartPromotion } from 'catering/hooks/query';

export function useHandleExternalPromotion() {
  const queryParams = useQueryParams();
  const { promo } = queryParams;

  const { mutate, isSuccess, error } = useCreateCartPromotion();

  useEffect(() => {
    if (promo) {
      mutate(promo);
    }
  }, [promo, mutate]);

  return { isSuccess, error };
}
